import { render, staticRenderFns } from "./ModalCopayment.vue?vue&type=template&id=8c7e5dea&scoped=true&"
import script from "./ModalCopayment.vue?vue&type=script&lang=js&"
export * from "./ModalCopayment.vue?vue&type=script&lang=js&"
import style0 from "./ModalCopayment.vue?vue&type=style&index=0&id=8c7e5dea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7e5dea",
  null
  
)

export default component.exports